import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import styles from './AdminSidebar.module.css';

const AdminSidebar = ({ isOpen, onClose }) => {
  const location = useLocation();

  const menuItems = [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: '📊',
      path: '/admin/dashboard'
    },
    {
      id: 'products',
      label: 'Productos',
      icon: '📦',
      path: '/admin/products'
    },
    {
      id: 'attributes',
      label: 'Variables de Producto',
      icon: '🏷️',
      path: '/admin/attributes'
    },
    {
      id: 'orders',
      label: 'Órdenes',
      icon: '🛒',
      path: '/admin/orders'
    },
    {
      id: 'offers',
      label: 'Ofertas',
      icon: '🏷️',
      path: '/admin/offers'
    },
    {
      id: 'categories',
      label: 'Categorías',
      icon: '📁',
      path: '/admin/configurations'
    }
    /*{
      id: 'analytics',
      label: 'Analíticas',
      icon: '📈',
      path: '/admin/analytics'
    }*/
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <>
      {isOpen && (
        <div className={styles.overlay} onClick={onClose} style={{ top: '64px' }} /> // Ajusta el top al alto del header
      )}
      <aside className={`${styles.adminSidebar} ${isOpen ? styles.open : ''}`}>
        <div className={styles.sidebarContent}>
          <div className={styles.logoSection}>
            <div className={styles.logoIcon}>🛍️</div>
            <span className={styles.logoText}>Nexa Globals</span>
          </div>

          <nav className={styles.navigation}>
            {menuItems.map((item) => (
              <Link
                key={item.id}
                to={item.path}
                className={`${styles.menuItem} ${isActive(item.path) ? styles.active : ''}`}
                onClick={onClose}
              >
                <span className={styles.menuIcon}>{item.icon}</span>
                <span className={styles.menuLabel}>{item.label}</span>
              </Link>
            ))}
          </nav>

          <div className={styles.footer}>
            <div className={styles.storeStatus}>
              <div className={styles.statusIndicator}></div>
              <span>Tienda Online</span>
              <span className={styles.statusText}>Activa</span>
            </div>
          </div>
        </div>
      </aside>
    </>
  );
};

export default AdminSidebar;